export const getProductionRecords = state => Object.values(state.productions.productionRecords);

